import { isBrowser } from 'portal-common-account/src/utils/device';
import { getRealHostName } from 'portal-common-account/src/utils/host';

const baseName = '/account';

const protocol = (isBrowser() ? location.protocol : 'https:').concat('//');

function getFinalUrl(path = '/', host) {
  const hostname = host || getRealHostName();
  return `${protocol}${hostname}${baseName}${path}`;
}

export const clsPrefix = 'intl-account';

export const PAGE_URL = {
  subAccountAddInfoUrl: getFinalUrl('/base/sub-account/addition-info'),

  accountAddInfoUrl: getFinalUrl('/base/root-account/addition-info'),

  sUrl: getFinalUrl(''),

  loginUrl: getFinalUrl('/login'),

  // 忘记密码url
  forgetPwdUrl: getFinalUrl('/password/recover'),
  forgetAccountUrl: getFinalUrl('/services/forgotAccount'),
  // 注册url
  registerUrl: getFinalUrl('/register'),
  // 完善注册信息Url
  completeRegisterUrl: getFinalUrl('/register/completion'),
  registerSuccessUrl: getFinalUrl('/register/success'),
  // 子账号登录页
  subAccountUrl: getFinalUrl('/login/subAccount'),

  // 合作伙伴 完善注册信息页
  partnerCompleteRegister: getFinalUrl('/register/partner?type=complete'),

  // 合作伙伴 企业申请信息填写页
  partnerRootCompanyApply: getFinalUrl('/partners/companyApplyInfo/index'),

  // 控制台页
  console: 'https://console.intl.cloud.tencent.com/',
  // 绑定mfa
  bindMFA: getFinalUrl('/login/bindMFA'),

  subAccountUnlockIpLimit: getFinalUrl('/login/subAccount/unlockIpLimit'),
};
